var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7295 170C88.7295 164.132 93.4865 159.375 99.3545 159.375H233.938C239.806 159.375 244.563 164.132 244.563 170C244.563 175.868 239.806 180.625 233.938 180.625H99.3545C93.4865 180.625 88.7295 175.868 88.7295 170Z",
    fill: "#4073F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.924 112.904C188.074 108.754 194.801 108.754 198.951 112.904L248.534 162.487C252.683 166.636 252.683 173.364 248.534 177.513L198.951 227.096C194.801 231.246 188.074 231.246 183.924 227.096C179.775 222.947 179.775 216.22 183.924 212.07L225.995 170L183.924 127.93C179.775 123.78 179.775 117.053 183.924 112.904Z",
    fill: "#4073F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.6b5edf876e3c8cf38b3f14482f93f436.svg";
export { ForwardRef as ReactComponent };